import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type EnrollmentStatus = {
  hasPayment: boolean
  canConfirmEnrollment: boolean
  /** false when the participant's current age falls outside the range allowed by the stay */
  isAgeCompliant: boolean
  /** the participant's age today — null when the enrollment carries no birth date */
  age: number | null
  /** lower bound of the allowed age range — null means unbounded */
  ageMinAllowed: number | null
  /** upper bound of the allowed age range — null means unbounded */
  ageMaxAllowed: number | null
}

export const defaultEnrollmentStatus: EnrollmentStatus = {
  hasPayment: true,
  canConfirmEnrollment: false,
  isAgeCompliant: true,
  age: null,
  ageMinAllowed: null,
  ageMaxAllowed: null
}

export function getEnrollmentStatus(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getStatus.url, { id }))
    .get<EnrollmentStatus>()
}
